module.exports = __webpack_public_path__ + "img/list-circle.133c1ca4.svg";